import React from 'react';

const Checkmark = () => {
  return (
    <div className="checkmark">
      <svg width="13" height="10" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M10.7363 17.8043L28.2721 0.268406C28.63 -0.0894688 29.2265 -0.0894688 29.5843 0.268406L31.7316 2.41566C32.0895 2.77353 32.0895 3.36999 31.7316 3.72787L11.3725 24.087C11.0146 24.4449 10.4579 24.4449 10.1 24.087L0.238583 14.2255C-0.0795278 13.9074 -0.0795278 13.311 0.238583 12.9531L2.4256 10.8058C2.78347 10.448 3.37993 10.448 3.69804 10.8058L10.7363 17.8043Z" fill="black" />
      </svg>
    </div>
  );
};

export default Checkmark;
